import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Logo from "../assets/logo/PNG/Paragon Yatırım_400x100 Dark mode.png"
import LogoWhite from "../assets/logo/PNG/Paragon Yatırım_400x100 Light Mode.png"
import { useTranslation } from 'react-i18next';

const Header = () => {
    const { t, i18n } = useTranslation();
    const [language, setLanguage] = useState(i18n.language || 'en');
    const navigate = useNavigate();

    const toggleLanguage = () => {
        const newLanguage = language === 'en' ? 'tr' : 'en';
        i18n.changeLanguage(newLanguage);
        setLanguage(newLanguage);
    };

    const handleMobileNavigation = (path) => {
        const offcanvas = document.querySelector('.offcanvas');
        const backdrop = document.querySelector('.offcanvas-backdrop');

        if (offcanvas) {
            offcanvas.classList.remove('show');
        }
        if (backdrop) {
            backdrop.remove();
        }

        document.body.classList.remove('overflow-hidden');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.classList.remove('modal-open');

        setTimeout(() => {
            navigate(path);
        }, 100);
    };

    return (
        <div className='header-content'>
            <div className="container desktop-header">
                <div className="row align-items-center justify-content-between">
                    <div className="col-lg-2">
                        <img src={Logo} alt="paragon-logo" width="200px" />
                    </div>
                    <div className="col-lg-10">
                        <ul className='list-unstyled mb-0 d-flex align-items-center justify-content-end navigation-menu'>
                            <li>
                                <Link to="/">{t('Ana Sayfa')}</Link>
                            </li>
                            <li>
                                <Link to="/about-us">{t('Hakkımızda')}</Link>
                            </li>
                            <li>
                                <Link to="/trading-platforms">{t('İşlem Platformları')}</Link>
                            </li>
                            <li>
                                <Link to="/investment-products">{t('Yatırım Ürünleri')}</Link>
                            </li>
                            {/* <li>
                                <Link to="/contact">İletişim</Link>
                            </li> */}
                            <li>
                                <Link to="/register">{t('Hesap Oluştur')}</Link>
                            </li>
                            <li>
                                <a
                                    href={(window.location.origin.includes("local") || window.location.origin.includes("test"))
                                        ? "https://scaparagon.testmedici.com"
                                        : window.location.origin.startsWith("www")
                                            ? window.location.origin.replace("www", "sca")
                                            : "https://sca." + window.location.hostname}
                                    target='_blank'>
                                    <button className="login-btn">
                                        {t('Giriş Yap')}
                                    </button>
                                </a>
                            </li>
                            <li>
                                <button className='language-btn' onClick={toggleLanguage}>
                                    {language === 'en' ?
                                        <div>
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Flag_of_Turkey.svg/2560px-Flag_of_Turkey.svg.png" alt="" width="40px" />
                                        </div>
                                        :
                                        <div>
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg/2560px-Flag_of_the_United_Kingdom_%283-5%29.svg.png" alt="" width="40px" />
                                        </div>
                                    }
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='mobile-header'>
                <div className="d-flex align-items-center justify-content-between">
                    <img src={Logo} alt="paragon-logo" width="125px" />
                    <button className="hamburger-btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                        <i className="fa-solid fa-bars fa-xl"></i>
                    </button>
                </div>
                <div className="offcanvas offcanvas-start" tabIndex={-1} id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                    <div className="offcanvas-header p-4">
                        <img src={LogoWhite} alt="paragon-logo" width="150px" />
                        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
                    </div>
                    <div className="offcanvas-body p-4">
                        <ul className='p-0 mb-0 list-unstyled'>
                            <li style={{ marginBottom: 30 }}>
                                <button className='language-btn' onClick={toggleLanguage}>
                                    {language === 'en' ?
                                        <div className='d-flex align-items-center gap-2'>
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Flag_of_Turkey.svg/2560px-Flag_of_Turkey.svg.png" alt="" width="40px" />
                                            <div className='text-dark'>Türkçe</div>
                                        </div>
                                        :
                                        <div className='d-flex align-items-center gap-2'>
                                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg/2560px-Flag_of_the_United_Kingdom_%283-5%29.svg.png" alt="" width="40px" />
                                            <div className='text-dark'>English</div>
                                        </div>
                                    }
                                </button>
                            </li>
                            <li>
                                <a onClick={() => handleMobileNavigation('/')}>{t('Ana Sayfa')}</a>
                            </li>
                            <li>
                                <a onClick={() => handleMobileNavigation('/about-us')}>{t('Hakkımızda')}</a>
                            </li>
                            <li>
                                <a onClick={() => handleMobileNavigation('/trading-platforms')}>{t('İşlem Platformları')}</a>
                            </li>
                            <li>
                                <a onClick={() => handleMobileNavigation('/investment-products')}>{t('Yatırım Ürünleri')}</a>
                            </li>
                            <li>
                                <a onClick={() => handleMobileNavigation('/register')}>{t('Hesap Oluştur')}</a>
                            </li>
                            <li>
                                <a
                                    href={(window.location.origin.includes("local") || window.location.origin.includes("test"))
                                        ? "https://scaparagon.testmedici.com"
                                        : window.location.origin.startsWith("www")
                                            ? window.location.origin.replace("www", "sca")
                                            : "https://sca." + window.location.hostname}
                                    target='_blank'>
                                    <button className="login-btn-mobile">
                                        {t('Giriş Yap')}
                                    </button>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;